module.exports = __webpack_public_path__ + "img/61800.147ec934.jpg";